import { RxCustomerAPI } from '@drifthq/dapper'

export const api = {
  getApiKeyForOrg(orgId) {
    return RxCustomerAPI.get(`/organizations/${orgId}/api_keys`)
      .map(res => res.response)
  },
  
  createApiKeyForOrg(orgId) {
    return RxCustomerAPI.post(`/organizations/${orgId}/api_keys`, { isProd: true })
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/modules/apiKey/api.js